<template>
  <v-main>
    <router-view />
  </v-main>
</template>

<script setup>
  //

  import AOS from 'aos';
  import 'aos/dist/aos.css'; // You can also use <link> for styles

  AOS.init({
            startEvent: 'DOMContentLoaded',
            offset: 100,
            delay: 100,
            duration: 400,
            useClassNames: true, // if true, will add content of `data-aos` as classes on scroll
            throttleDelay: 0, // the delay on throttle used while scrolling the page (advanced)
            once: false, // whether animation should happen only once - while scrolling down
            easing: 'ease',
            anchorPlacement: 'bottom-bottom', // defines which position of the element regarding to window should trigger the animation
        });

</script>
